import React from 'react';
import { Language, SecondaryLanguage } from '../types';
import { languages } from '../data/languages';

interface Props {
  secondaryLanguages: SecondaryLanguage[];
  onLanguageChange: (language: Language, proficiency: number | null) => void;
}

const SecondaryLanguageSelector: React.FC<Props> = ({ secondaryLanguages, onLanguageChange }) => {
  const handleCheckboxChange = (language: Language, checked: boolean) => {
    if (checked) {
      onLanguageChange(language, 1); // 默认熟练度为1
    } else {
      onLanguageChange(language, null);
    }
  };

  const handleProficiencyChange = (language: Language, proficiency: number) => {
    onLanguageChange(language, proficiency);
  };

  return (
    <div>
      <h2>Select Secondary Languages:</h2>
      {languages.map((language) => {
        const secondaryLang = secondaryLanguages.find(lang => lang.code === language.code);
        return (
          <div key={language.code}>
            <label>
              <input
                type="checkbox"
                checked={!!secondaryLang}
                onChange={(e) => handleCheckboxChange(language, e.target.checked)}
              />
              {language.name}
            </label>
            {secondaryLang && (
              <input
                type="number"
                min="1"
                max="10"
                value={secondaryLang.proficiency}
                onChange={(e) => handleProficiencyChange(language, parseInt(e.target.value, 10))}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default SecondaryLanguageSelector;